import { render, staticRenderFns } from "./EditData.vue?vue&type=template&id=2a006a4e&scoped=true"
import script from "./EditData.vue?vue&type=script&lang=js"
export * from "./EditData.vue?vue&type=script&lang=js"
import style0 from "./EditData.vue?vue&type=style&index=0&id=2a006a4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a006a4e",
  null
  
)

export default component.exports